export default __webpack_public_path__ + "static/media/quikventoryPlaceholder.18b17b7f.jpg";